import { proxy, useSnapshot } from 'valtio';
import type { CollectorCommentsQuery } from '@graphql/reactQuery';

export type Comment = NonNullable<
  NonNullable<CollectorCommentsQuery['release']>['collectorComments']['edges'][number]['node']
>;

type CommentsState = {
  commentsScrollIndices: Record<string, number | undefined>;
};

const initialCommentsState: CommentsState = {
  commentsScrollIndices: {},
};

export const CommentsState: CommentsState = proxy(initialCommentsState);

export const useCommentsState = () => useSnapshot(CommentsState);
